import _slicedToArray from "/usr/app/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
var __jsx = React.createElement;
import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import stl from "./UnbxdMobileTextSearch.module.css";
import useUnbxdTextSearch from "../../../../../../../common/hooks/useUnbxdTextSearch";
import loadable from "@loadable/component";
import { useTranslation } from "@i18n";
import { CDN_LINK } from "@globalConfig";
import useHelpers from "@hooks/useHelpers";
import { useAuthActions } from "@/_MiniApps/auth/AuthContext";
import { createPortal } from "react-dom";
import useLocalStorage from "@hooks/useLocalStorage";
import { Icon } from "@syarahtech/ui";
import { twMerge } from "tailwind-merge";
var fallback = {
  fallback: null
};
var UnbxdMobileTextSearchPopUp = loadable({
  resolved: {},
  chunkName: function chunkName() {
    return "UnbxdMobileTextSearchPopUp";
  },
  isReady: function isReady(props) {
    var key = this.resolve(props);
    if (this.resolved[key] !== true) {
      return false;
    }
    if (typeof __webpack_modules__ !== 'undefined') {
      return !!__webpack_modules__[key];
    }
    return false;
  },
  importAsync: function importAsync() {
    return import(/* webpackChunkName: "UnbxdMobileTextSearchPopUp" */"./UnbxdMobileTextSearchPopUp");
  },
  requireAsync: function requireAsync(props) {
    var _this = this;
    var key = this.resolve(props);
    this.resolved[key] = false;
    return this.importAsync(props).then(function (resolved) {
      _this.resolved[key] = true;
      return resolved;
    });
  },
  requireSync: function requireSync(props) {
    var id = this.resolve(props);
    if (typeof __webpack_require__ !== 'undefined') {
      return __webpack_require__(id);
    }
    return eval('module.require')(id);
  },
  resolve: function resolve() {
    if (require.resolveWeak) {
      return require.resolveWeak("./UnbxdMobileTextSearchPopUp");
    }
    return eval('require.resolve')("./UnbxdMobileTextSearchPopUp");
  }
}, fallback);
var UnbxdMobileTextSearch = function UnbxdMobileTextSearch(_ref) {
  var referral_location = _ref.referral_location,
    customClass = _ref.customClass,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? "default" : _ref$variant;
  var isNavbar = variant === "navbar";
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useState = useState(false),
    showPopup = _useState[0],
    setShowPopup = _useState[1];
  var _useSearchParams = useSearchParams(),
    _useSearchParams2 = _slicedToArray(_useSearchParams, 1),
    searchParams = _useSearchParams2[0];
  var searchTermParam = searchParams.get("text");
  var _useHelpers = useHelpers(),
    createUrl = _useHelpers.createUrl;
  var _useAuthActions = useAuthActions(),
    syncSearchHistoryOnLogin = _useAuthActions.syncSearchHistoryOnLogin; // Access the function
  var navigate = useNavigate();
  var _useUnbxdTextSearch = useUnbxdTextSearch(setShowPopup),
    searchTerm = _useUnbxdTextSearch.searchTerm,
    searchTermSuggestions = _useUnbxdTextSearch.searchTermSuggestions,
    handleSearchTermChange = _useUnbxdTextSearch.handleSearchTermChange,
    handleTextSearch = _useUnbxdTextSearch.handleTextSearch,
    setSearchTerm = _useUnbxdTextSearch.setSearchTerm,
    setSearchTermSuggestions = _useUnbxdTextSearch.setSearchTermSuggestions;
  var _useLocalStorage = useLocalStorage(false),
    setLocalStorage = _useLocalStorage.setLocalStorage;

  /**
   * Clears the term everywhere it is held: the input, the suggestion list, and
   * the `?text=` param.
   *
   * The last one matters — the closed trigger renders `searchTermParam`, not
   * `searchTerm`, so clearing state alone left the modal empty while the pill
   * behind it still showed the old term (and the `searchTermParam` effect below
   * then wrote it straight back into state).
   *
   * Only navigates when there is a term to drop, so closing the modal on a page
   * with no active search does not move the user to /filters.
   */
  var clearSearch = function clearSearch() {
    setSearchTerm("");
    setSearchTermSuggestions([]);
    if (searchTermParam) {
      navigate(createUrl("/filters"));
    }
  };
  useEffect(function () {
    if (showPopup) {
      document.body.style.overflow = "hidden";
      setLocalStorage('text_search_referral_location', referral_location);
    } else {
      document.body.style.overflow = "unset";
    }
  }, [showPopup]);
  useEffect(function () {
    if (!searchTermParam) {
      setSearchTerm("");
      setSearchTermSuggestions([]);
      return;
    }
    setSearchTerm(searchTermParam);
  }, [searchTermParam]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: twMerge(stl.textSearch, "abSearchTextClass", isNavbar && stl.navbarTrigger, customClass, searchTermParam && "justify-between"),
    onClick: function onClick() {
      setShowPopup(true);
      syncSearchHistoryOnLogin();
    },
    id: "unbxd-text-mobile-search_bar-container"
  }, !searchTermParam ? isNavbar ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Icon, {
    icon: "mingcute--search-2-line",
    width: 4,
    height: 4,
    className: "shrink-0 -scale-x-100 text-[#6b7ea5]"
  }), /*#__PURE__*/React.createElement("span", {
    className: "interActiveGray"
  }, t("search_make_model", {
    ns: "web_search"
  }))) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
    className: "interActiveGray"
  }, t("search_make_model", {
    ns: "web_search"
  })), /*#__PURE__*/React.createElement("img", {
    className: stl.searchIconN,
    src: CDN_LINK + "/assets/images/text-search-icon.svg",
    width: 15,
    height: 15,
    alt: "text-search-icon",
    "aria-label": "text-search-icon"
  })) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
    className: stl.active
  }, searchTermParam), /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "".concat(stl.clear, " hasEvents"),
    onClick: function onClick(e) {
      e.stopPropagation();
      clearSearch();
    }
  }, /*#__PURE__*/React.createElement("img", {
    src: CDN_LINK + "/assets/images/blueX.svg",
    alt: "Clear search",
    height: 12,
    width: 12
  })))), showPopup && /*#__PURE__*/createPortal(/*#__PURE__*/React.createElement(UnbxdMobileTextSearchPopUp, {
    searchTerm: searchTerm,
    imgClick: function imgClick() {
      setShowPopup(false);
      clearSearch();
    },
    handleSearchTermChange: handleSearchTermChange,
    handleTextSearch: handleTextSearch,
    searchTermSuggestions: searchTermSuggestions
  }), document.getElementById("BodyPortal")));
};
export default UnbxdMobileTextSearch;